import React, {Component} from "react";
import '../../EMR.css';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TextInput from "../../../../../components/text-input/TextInput";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import GreenSwitchWithMessage from "../../../../../components/switch/GreenSwitchWithMessage";
import CheckboxInput from "../../../../../components/checkbox-input/CheckboxInput";
import ExpansionPanel from "../../../../../components/expansion-panel/CustomExpansionPanel";
import RedAsterisk from "../../../../../components/asterisk/RedAsterisk";
import {AssessmentReviewOfSystemChecker} from "../checkers/AssessmentReviewOfSystemChecker";

export default class AssessmentReviewOfSystemModal extends Component {

    state = {}

    render() {
        let toggleOn = AssessmentReviewOfSystemChecker.isToggleOn(this.props.assessment.reviewOfSystem);
        let isNone = AssessmentReviewOfSystemChecker.isNone(this.props.assessment.reviewOfSystem);

        const expansionPanels = [
            {title: 'Cardiovascular / Circulatory', content: this.contentDiv("cardiovascularCirculatory")},
            {title: 'Respiratory', content: this.contentDiv("respiratory")},
            {title: 'Head, Neck, Eyes', content: this.contentDiv("headNeckEyes")},
            {title: 'ENT', content: this.contentDiv("ent")},
            {title: 'Skin, Hair, Nails', content: this.contentDiv("skinHairNails")},
            {title: 'Lymphatic / Immune', content: this.contentDiv("lymphaticImmune")},
            {title: 'Endocrine', content: this.contentDiv("endocrine")},
            {title: 'Gastrointestinal', content: this.contentDiv("gastrointestinal")},
            {title: 'Genitourinary', content: this.contentDiv("genitourinary")},
            {title: 'Musculoskeletal', content: this.contentDiv("musculoskeletal")},
            {title: 'Neurological', content: this.contentDiv("neurological")},
        ]

        return (
            <div className={"emr-modal content-row emr-background"} style={{width: "100%"}}>
                <div style={{width: "100%", margin: "20px"}}>
                    <div style={{display: "flex"}}>
                        <div className="content-label" style={{margin: "auto", marginLeft: "0px"}}>Review of Systems <RedAsterisk appointmentType={this.props.appointmentType} firstVisit
                                                                                                                                  newComplaint/>
                        </div>
                        <GreenSwitchWithMessage
                            checked={toggleOn}
                            onChange={(value) => {
                                if (toggleOn) {
                                    let id = this.props.assessment.reviewOfSystem.id;
                                    this.props.assessment.reviewOfSystem = {
                                        id: id,
                                        cardiovascularCirculatoryNormal: true,
                                        respiratoryNormal: true,
                                        headNeckEyesNormal: true,
                                        entNormal: true,
                                        skinHairNailsNormal: true,
                                        lymphaticImmuneNormal: true,
                                        endocrineNormal: true,
                                        gastrointestinalNormal: true,
                                        genitourinaryNormal: true,
                                        musculoskeletalNormal: true,
                                        neurologicalNormal: true
                                    };
                                    this.props.assessment.reviewOfSystem.none = value;
                                    this.forceUpdate();
                                }
                            }}/>
                    </div>

                    <div style={{display: "flex", marginLeft: "5px"}}>
                        <div>
                            <CheckboxInput value={isNone}
                                           onChange={(value) => {

                                               if (value) {
                                                   let id = this.props.assessment.reviewOfSystem.id;
                                                   this.props.assessment.reviewOfSystem = {
                                                       id: id,
                                                       cardiovascularCirculatoryNormal: true,
                                                       respiratoryNormal: true,
                                                       headNeckEyesNormal: true,
                                                       entNormal: true,
                                                       skinHairNailsNormal: true,
                                                       lymphaticImmuneNormal: true,
                                                       endocrineNormal: true,
                                                       gastrointestinalNormal: true,
                                                       genitourinaryNormal: true,
                                                       musculoskeletalNormal: true,
                                                       neurologicalNormal: true
                                                   };
                                                   this.setState({allNormal: value});
                                                   this.props.assessment.reviewOfSystem.none = value;
                                                   this.forceUpdate();
                                               }
                                           }}/>
                        </div>
                        <div style={{marginTop: "-2px", marginLeft: "5px", marginRight: "5px"}}>All Normal</div>
                    </div>

                    <br/>
                    <br/>

                    {
                        expansionPanels.map(expansionPanel => this.wrapperPanel(expansionPanel.title, expansionPanel.content))
                    }
                </div>
            </div>
        );
    }

    wrapperPanel = (title, content) => {
        return (
            <ExpansionPanel>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography>{title}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    {content}
                </ExpansionPanelDetails>
            </ExpansionPanel>
        )
    }

    contentDiv(field) {
        if (this.props.assessment.reviewOfSystem == null) {
            return (<div>All Normal</div>);
        }

        if (this.props.assessment.reviewOfSystem[field] == null) {
            this.props.assessment.reviewOfSystem[field] = [];
        }

        if (this.state[field] == null) {
            this.setState({[field]: ""});
        }

        const list = this.props.assessment.reviewOfSystem[field];
        let divs = this.getDivs(list, field);
        const isFieldNormal = this.props.assessment.reviewOfSystem[field + "Normal"];
        const isFieldNA = isFieldNormal === undefined || isFieldNormal === null;
        return (
            <div style={{width: "100%"}}>
                <div className={"row no-margin"}>
                    <div style={{display: "flex", marginLeft: "5px"}}>
                        <div>
                            <CheckboxInput value={isFieldNA}
                                           onChange={value => {
                                               if (value) {
                                                   this.props.assessment.reviewOfSystem[field + "Normal"] = null;
                                                   this.props.assessment.reviewOfSystem[field] = [];
                                                   this.props.assessment.reviewOfSystem.none = false;
                                               }
                                               this.forceUpdate();
                                           }}/>
                        </div>
                        <div style={{marginTop: "-2px", marginLeft: "5px", marginRight: "5px"}}>N/A</div>
                    </div>
                    <div style={{display: "flex", marginLeft: "5px"}}>
                        <div>
                            <CheckboxInput value={isFieldNormal === true}
                                           onChange={value => {
                                               if (value) {
                                                   this.props.assessment.reviewOfSystem[field + "Normal"] = true;
                                                   this.props.assessment.reviewOfSystem[field] = [];

                                                   const review = this.props.assessment.reviewOfSystem;
                                                   if (review.cardiovascularCirculatoryNormal && review.respiratoryNormal &&
                                                       review.headNeckEyesNormal && review.entNormal && review.skinHairNailsNormal &&
                                                       review.lymphaticImmuneNormal && review.endocrineNormal &&
                                                       review.gastrointestinalNormal && review.genitourinaryNormal &&
                                                       review.musculoskeletalNormal && review.neurologicalNormal) {
                                                       review.none = true;
                                                   }
                                               }
                                               this.setState({})
                                               this.forceUpdate();
                                           }}/>
                        </div>
                        <div style={{marginTop: "-2px", marginLeft: "5px", marginRight: "5px"}}>Normal</div>
                    </div>
                    <div className={"col-11"} style={{padding: "5px 0px"}}>
                        <TextInput value={this.state[field]}
                                   placeholder={"Details"}
                                   onChange={value => this.setState((state) => {
                                       state[field] = value;
                                       return state;
                                   })}
                                   style={{fontSize: "14px", width: "100%"}}
                        />
                    </div>
                    <div className={"col-1"} style={{flexFlow: "row-reverse", display: "flex", padding: "5px 0px"}}>
                        <Button className={"emr-plus-button"}
                                variant="success"
                                disabled={!(this.state[field] != "")}
                                style={{fontSize: "12px"}}
                                onClick={() => {
                                    list.push(this.state[field]);
                                    this.props.assessment.reviewOfSystem[field + "Normal"] = false;
                                    this.props.assessment.reviewOfSystem.none = false;
                                    this.setState((state) => {
                                        state[field] = "";
                                        return state;
                                    })
                                }}>
                            <FontAwesomeIcon icon={["fas", "plus"]}/>
                        </Button>
                    </div>
                </div>
                <div className={"row no-margin"}>
                    <div className={"div-list-wrapper"}>
                        {divs}
                    </div>
                </div>
            </div>
        );
    }

    getDivs(list, field) {
        let divs = [];
        if (list == null || list.length == 0) {
            return null;
        }

        list.forEach((d, index) => {
            divs.push(
                <div className={"div-list-item"} key={field + index} style={{backgroundColor: "rgb(250,250,250)"}}>
                    <div>
                        {d}
                    </div>
                    <Button className={"emr-transparent-delete-button"}
                            variant="warning"
                            style={{fontSize: "10px", marginLeft: "2px"}}
                            onClick={() => {
                                this.props.assessment.reviewOfSystem[field].splice(index, 1);
                                this.forceUpdate();
                            }}>
                        <FontAwesomeIcon icon={["fas", "times"]}/>
                    </Button>
                </div>
            );
        })

        return divs;
    }
}